import { useHttp } from "../http/useHttp";
import { useAxiosMfaMutation } from "../http/useAxiosMfaMutation";
import { paths } from "../generated-types";
import { useDefaultError } from "@synota-io/synota-shared-ui";

type BluePenguinInviteOperation = paths["/dashboard/synota/blue-penguin/invite"]["post"];
export type UseBluePenguinInviteUserInput =
  BluePenguinInviteOperation["requestBody"]["content"]["application/json"];
export type UseBluePenguinInviteUserResponse =
  BluePenguinInviteOperation["responses"][200]["content"]["text/plain"];

export const useBluePenguinInviteUser = () => {
  const { client } = useHttp();

  const { isPending, status, data, error, mutate } = useAxiosMfaMutation<
    UseBluePenguinInviteUserResponse,
    UseBluePenguinInviteUserInput
  >({
    mutationKey: ["blue-penguin-invite-user"],
    mutationFn: (input) => client.post("/synota/blue-penguin/invite", input),
  });

  useDefaultError(error, "Failed to invite Blue Penguin user");

  return {
    inviteUser: mutate,
    isPending,
    status,
    inviteResult: data,
    error,
  };
};

export type UseBluePenguinInviteUserReturn = ReturnType<typeof useBluePenguinInviteUser>;
